module.exports = __webpack_public_path__ + "assets/img/mountains.6e7977da.png";